<template>
  <article>
    <div class="filter-row">
      <dropdown
        v-if="getStockCategories && getStockCategories.length > 0"
        :arrDropdown="getStockCategories"
        :alias="`category`"
        data-action="filter_stock_category"
        :defaultItem="defaultCategory"
        :defaultLevel="defaultLevelType"
        :placeholder="`All Category`"
        @select-data="insertQs"
      />
    </div>
    <div :class="[ shouldStick ? 'period-sticky-top' : 'period-remove-sticky-top']">
      <div class="select-period-row">
        <period-navigation
          data-action="change_stock_period"
          :arrPeriod="arrPeriod"
          :alias="`period`"
          @select-data="insertQs"
          :defaultItem.sync="defaultPeriod"
          :slidePerPage="6"
        />
      </div>
    </div>
    <section id="list-stock">
      <list-market
        data-action="open_stock"
        data-list="market_stock"
        :items="getStockFilter"
        v-if="getStockFilter.length"
        :type="'stock'"
        @select-data="insertQs"
        :wantLoaing="true"
      />
    </section>
  </article>
</template>
<script>
import GlobalMarketFunc from "../../../../components/mixins/global-market-functions";
import PeriodNavigation from "../../../../components/miniapp/global/PeriodNavigation.vue";
import ListMarket from "../../../../components/miniapp/market/List";
import Dropdown from "../../../../components/miniapp/global/Dropdown.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  mixins: [GlobalMarketFunc],
  components: {
    PeriodNavigation,
    ListMarket,
    Dropdown
  },
  data() {
    return {
      defaultCategory: "",
      defaultPeriod: "1Y",
      defaultLevelType: "",
      shouldStick: true,
      objQuery: {},
      arrPeriod: ["1D", "1M", "6M", "1Y", "3Y", "5Y"]
    };
  },
  computed: {
    ...mapGetters("stock", ["getStockCategories", "getStockFilter"])
  },
  async created() {
    window.scroll(0, 0);

    if (this.$route.query.period) {
      this.objQuery.period = this.$route.query.period;
      this.defaultPeriod = this.$route.query.period;
    } else {
      this.objQuery.period = this.defaultPeriod;
    }

    if (this.$route.query.industry_no) {
      this.objQuery.industry_no = this.$route.query.industry_no;
      this.defaultCategory = this.$route.query.industry_no;
      this.defaultLevelType = "parent";
    }

    if (this.$route.query.sector_no) {
      this.objQuery.sector_no = this.$route.query.sector_no;
      this.defaultCategory = this.$route.query.sector_no;
      this.defaultLevelType = "children";
    }

    this.objQuery.limit = 20;
    await this.findStockCategories();
    this.mixins_global_getStockFilter(this.objQuery);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions("stock", ["findStockCategories"]),
    async insertQs(val, alias) {
      if (alias == "category") {
        if (val.children) {
          this.objQuery.industry_no = val.value;
          this.objQuery.sector_no = "";
          this.defaultLevelType = "parent";
        } else {
          this.objQuery.industry_no = "";
          this.objQuery.sector_no = val.value;
          this.defaultLevelType = "children";
        }
        this.defaultCategory = val.value ? val.value.toString() : "";
      } else if (alias == "amc") {
        this.objQuery.amc = val;
      } else if (alias == "period") {
        this.objQuery.period = val;
      } else if (alias == "dividend") {
        this.objQuery.dividend = [val];
      } else if (alias == "page") {
        this.objQuery.page = val;
      } else if (alias == "limit") {
        this.objQuery.limit = val;
      } else if (alias == "period") {
        this.objQuery.period = val;
      }
      await this.mixins_global_getStockFilter(this.objQuery);
    },
    handleScroll() {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      currentScrollPosition > 73 ? (this.shouldStick = true) : (this.shouldStick = false);
      this.$emit("current-scroll", currentScrollPosition);
    }
  }
};
</script>

<style lang="scss" scoped>
.top-sticky {
  .select-period-row {
    padding-top: 48px;
  }
}
.filter-row {
  padding: 12px 15px;
}
#list-stock {
  // @extend %container-style;
  padding-right: 0px;
  padding-left: 0px;
}
</style>